import { render, staticRenderFns } from "./PdpProductDetails.vue?vue&type=template&id=6b3cfca3&"
import script from "./PdpProductDetails.vue?vue&type=script&lang=js&"
export * from "./PdpProductDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports